import * as types from './mutation-types'

export default {
  SET_SHOP_ALERTS(state, alerts) {
    state.alerts = Object.fromEntries(alerts.map(alert => [alert.shop_id, alert]))
  },
  [types.ADD_SHOPS](state, data) {
    state.shops = data.shops
  },
  [types.ADD_SHOP](state, data) {
    state.shops.push(data)
  },
  [types.SET_POS_CHECKOUT_STATUS](state, data) {
    state.posCheckoutStatus = data
  },
  [types.SET_POS_CHECKOUT_DETAILS](state, data) {
    state.checkoutDetails = data?.checkout
  },
  [types.SET_SHOP_DEFAULT_CURRENCY](state, data) {
    state.defaultCurrency = data.currency_symbol || data.symbol_native
  },
  [types.LOAD_SHOP_PRODUCT_SALE_ELEMENTS_BY_CATEGORIES](state, data) {
    state.product_sale_elements_by_categories = data.data
  },
  [types.LOAD_SHOP_PRODUCT_SALE_ELEMENTS](state, data) {
    state.product_sale_elements = data.product_sale_element
  },
  [types.LOAD_SHOP_CATEGORIES](state, data) {
    state.categories = data.categories
  },
}
